import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { ConfigValuesApp } from '@/app/common/config/configuration/configurationTypes.ts';

// The part of the localization the widget defaults read: the language and locale for the dictionary,
// the country for the origin airport and the default suggestion, the two hub item lists for the widget
// origin and destination, and the open search flag. The browser sends it to the searchDefaultData
// route on every widget refresh, so it must stay this small: the whole Localization carries every CMS
// config value and would be uploaded each time.
export type SearchDefaultDataLocalization = Pick<
  Localization,
  'lang' | 'locale' | 'country' | 'defaultOriginItems' | 'defaultDestinationItems'
> & {
  configValuesApp: Pick<ConfigValuesApp, 'disableOpenSearch'>;
};

export const toSearchDefaultDataLocalization = ({
  lang,
  locale,
  country,
  defaultOriginItems,
  defaultDestinationItems,
  configValuesApp,
}: Localization): SearchDefaultDataLocalization => ({
  lang,
  locale,
  country,
  defaultOriginItems,
  defaultDestinationItems,
  configValuesApp: { disableOpenSearch: configValuesApp.disableOpenSearch },
});
